export default function Checkbox({ label, onChange, defaultValue }) {
    return (
      <label>
        {/* {label} */}
        <input type="checkbox" title={label} onChange={onChange} defaultChecked={defaultValue}/>
      </label>
    )
  }